/* Copy link, with a short confirmation on the button */
(function () {
    'use strict';

    function copy(text) {
        if (navigator.clipboard && window.isSecureContext) {
            return navigator.clipboard.writeText(text);
        }
        return new Promise(function (resolve, reject) {
            var field = document.createElement('textarea');
            field.value = text;
            field.setAttribute('readonly', '');
            field.style.position = 'fixed';
            field.style.opacity = '0';
            document.body.appendChild(field);
            field.select();
            var ok = document.execCommand('copy');
            document.body.removeChild(field);
            if (ok) {
                resolve();
            } else {
                reject(new Error('copy failed'));
            }
        });
    }

    document.addEventListener('click', function (event) {
        var button = event.target.closest('[data-copy-link]');
        if (!button) {
            return;
        }
        copy(button.getAttribute('data-copy-link')).then(function () {
            button.setAttribute('data-copied', '');
            window.setTimeout(function () {
                button.removeAttribute('data-copied');
            }, 2000);
        });
    });
})();
